import { __rest } from "tslib";
import { ALLOW_ALL_KEY, ALWAYS_PRESENT_PROVIDERS } from '../constants';
const entriesToState = (initialRecords, entries, entryData = {}) => {
    var _a;
    const indexes = {};
    const state = initialRecords.map((provider, index) => {
        indexes[provider.hostName] = index;
        return Object.assign(Object.assign({}, provider), { allowed: false });
    });
    for (const [hostName, displayName] of entries) {
        const index = (_a = indexes[hostName]) !== null && _a !== void 0 ? _a : state.length;
        indexes[hostName] = index;
        state[index] = Object.assign({ allowed: false, displayName,
            hostName }, entryData);
    }
    return state;
};
const defaultInitialState = {
    allowAll: false,
    providers: [],
};
export const prepareState = (storage, initialState = defaultInitialState) => {
    const _a = storage, _b = ALLOW_ALL_KEY, allowAll = _a[_b], providersRecords = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
    const minimalProviders = entriesToState(initialState.providers, ALWAYS_PRESENT_PROVIDERS, { allowed: false });
    const providers = entriesToState(minimalProviders, Object.entries(providersRecords), { allowed: true });
    return {
        allowAll: Boolean(allowAll),
        providers,
    };
};
//# sourceMappingURL=utils.js.map